import { render, staticRenderFns } from "./customer-review.vue?vue&type=template&id=24bca8ea"
import script from "./customer-review.vue?vue&type=script&lang=js"
export * from "./customer-review.vue?vue&type=script&lang=js"
import style0 from "./customer-review.vue?vue&type=style&index=0&id=24bca8ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports